const formatTime = (time) => {
    const getSeconds = `${time % 60}`.slice(-2);
    const getMinutes = `${Math.floor(time / 60) % 60}`.slice(-2);
    const getHours = `${Math.floor(time / 3600) % 24}`.slice(-2);
    const getDays = `${Math.floor(time / 86400)}`;

    if (getMinutes === "0" && getHours === "0" && getDays === "0") {
        return `${getSeconds}s`;
    } else if (getHours === "0" && getDays === "0") {
        return `${getMinutes}m ${getSeconds}s`;
    } else if (getDays === "0") {
        return `${getHours}h ${getMinutes}m ${getSeconds}s`;
    } else {
        return `${getDays}d ${getHours}h ${getMinutes}m ${getSeconds}s`;
    }
};

module.exports = formatTime;
